import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class MobileService {
	isAndroid(): boolean {
		return navigator.userAgent.match(/Android/i) !== null;
	}

	isBlackBerry(): boolean {
		return navigator.userAgent.match(/BlackBerry/i) !== null;
	}

	isiOS(): boolean {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null;
	}

	isOpera(): boolean {
		return navigator.userAgent.match(/Opera Mini/i) !== null;
	}

	isWindows(): boolean {
		return (
			navigator.userAgent.match(/IEMobile/i) !== null ||
			navigator.userAgent.match(/WPDesktop/i) !== null
		);
	}

	/**
	 *
	 * @returns Renvoi un booleen indiquant sur l'utilisateur utilise un mobile
	 */
	isMobile(): boolean {
		return (
			this.isAndroid() ||
			this.isBlackBerry() ||
			this.isiOS() ||
			this.isOpera() ||
			this.isWindows()
		);
	}
}
